
import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";


export const setActiveStep = (step) => {
  return { type: types.certificadoAtencionSetStep, payload: step };
};

export const setAfiliadoSeleccionado = (afiliado) => {
  return {
    type: types.certificadoAtencionSetAfiliadoSeleccionado,
    payload: afiliado,
  };
};

export const cleanAfiliadoSeleccionado = () => {
  return { type: types.certificadoAtencionCleanAfiliadoSeleccionado };
};

export const clearReducer = () => {
  return { type: types.certificadoAtencionClearReducer };
};

export const setShowForm = (boolean) => {
  return {
    type: types.certificadoAtencionSetShowForm,
    payload: boolean,
  };
};

export const setCertificadoSelec = (certificado) => {
  return {
    type: types.setCertificadoAtencionSeleccionado,
    payload: certificado,
  };
};

export const consultarCertificadosPorAfiliado = (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
  if (idAfiliado === null) {
    idAfiliado = 0
  }
  if (idAfiliadoExterno === null) {
    idAfiliadoExterno = 0
  }
  try {
    const response = await fetchConToken(
      `CertificadosAtencion/ConsultaPorAfiliado/${idAfiliado},${idAfiliadoExterno}`,
    );
    const body = await response.json();

    if (response.ok) {
      dispatch({
        type: types.certificadosAtencionSucess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar los certificados.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const nuevoCertificadoAsistencia = (datos) => async (dispatch) => {

  if (datos.idAfiliado === null) {
    datos.idAfiliado = 0
  }
  if (datos.idAfiliadoExterno === null) {
    datos.idAfiliadoExterno = 0
  }
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(
      `CertificadosAtencion`,
      datos,
      'POST',
    );
    const body = await response.json();

    if (response.ok) {
      dispatch(setCertificadoSelec(body));
      dispatch(
        startAlerta(
          'Certificado creado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al crear el certificado.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const imprimirPDFCertificado = (id, setRedirect = null, finalizar = false) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `CertificadosAtencion/generarPDF/${id}`,
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const body = await response.blob();
        if (response.ok) {
          dispatch(finishSpinner());
          window.open(URL.createObjectURL(body));
          setRedirect && setRedirect(true);
        } else {
          throw body;
        }
      } else {
        const error = await response.json();
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          error,
          "Ocurrio un error en la generación del PDF",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en la generación del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const enviarPDFCertificado = (id, setRedirect = null, finalizar = false) => {
  
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `CertificadosAtencion/generarMail/${id}`,
      );
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        setRedirect && setRedirect(true);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};
